import styled from 'styled-components'

export const StyledShopAnnotation = styled.div`
  font-style: italic;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #5C5C5C;

  span:first-child {
    color: #CC3333;
    font-weight: 700;
  }

  span:nth-child(2) {
    font-weight: 700;
  }
`

export const StyledShopAnnotationWmo = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #5C5C5C;
  background-color: #F4F4F4;
  padding: 4px;
  border-radius: 4px;

  span:first-child {
    font-weight: 500;
  }

  span:nth-child(2) {
    font-weight: 600;
  }
`
